import {
	StyledCompactCardSelect,
	StyledButton,
	StyledDropDown,
	StyledCheckBox,
	StyledRadioButtons,
	StyledCardSelect,
	StyledImageSelect,
	StyledColorSelect,
	StyledQuantitySelect,
	StyledTextBox,
	StyledSlider,
	StyledToggleButton,
} from "@animech/ui";

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import * as StyledColorPicker from "../../widgets/color-picker/color-picker.style";

export const SceneElementChild = styled.div``;

export const SceneElementContainer = styled.div`
	${() => css`
		pointer-events: none;

		${SceneElementChild} {
			position: absolute;
			opacity: 1;
			transition: opacity 0.2s ease-in-out;

			&[data-hidden="true"] {
				opacity: 0;
			}

			/* This class controls the exit animation for scene elements */
			&.item-exit-active {
				/* Apply fade out and rotate animation to ColorPicker */
				${StyledColorPicker.ColorPicker} {
					animation-name: ${StyledColorPicker.fadeOutRotate};
				}
			}

			${StyledCompactCardSelect.Root}, ${StyledButton.Root}, ${StyledDropDown.Root}, ${StyledCheckBox.Root}, ${StyledRadioButtons.Root}, ${StyledCardSelect.Root}, ${StyledImageSelect.Root}, ${StyledColorSelect.ColorSelectItem}, ${StyledQuantitySelect.Root}, ${StyledTextBox.Root}, ${StyledSlider.Root}, ${StyledToggleButton.Root} {
				pointer-events: all;
			}
		}
	`}
`;
